/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-09 11:03:40
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-06-21 17:24:41
 * @FilePath: /unifyxp-v2-store-portal/src/components/LinkModule/Components/ItemWithPic/index.tsx
 */
import React from 'react';

import { Tooltip } from 'antd';

import styles from './style.module.less';

type Props = {
  image: string;
  onClick: (item: any) => void;
  title: string;
  desc: string;
  selected?: boolean;
};

function ItemWithPic({ image, onClick, title, desc, selected }: Props) {
  return (
    <div
      style={{
        backgroundColor: selected ? '#E5F7E9' : undefined,
      }}
      className={styles.container}
      onClick={onClick}>
      <div
        className={styles.pic}
        style={{
          backgroundImage: image ? `url('${image}')` : undefined,
        }}></div>
      <Tooltip
        title={
          <>
            <div className={styles.title}>{title}</div>
            <div className={styles.desc}>{desc}</div>
          </>
        }>
        <div className={styles.right}>
          <div className={styles.title}>{title}</div>
          <div className={styles.desc}>{desc}</div>
        </div>
      </Tooltip>
    </div>
  );
}

export default ItemWithPic;
